import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { WelcomeScreenClassicEditor } from '../../../assets/illustrations/welcome-screen-classic-editor';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useMultilingualWarning } from '../../../hooks/use-multilingual-warning';
import { useOnMount } from '../../../hooks/use-on-mount';
import { isClassicEditorHost } from '../../../utils/get-editor-host';
import { MissingSavePermissionWarning } from '../../../warnings/missing-save-permission-warning';
import { SecondaryBranchWarning } from '../../../warnings/secondary-branch-error';
import { SecondaryLanguageWarning } from '../../../warnings/secondary-language-error';
export const WizardPanelContentWelcome = _ref => {
  let {
    hasSavePermission,
    isPublishedBranch
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    shouldShowSecondaryLanguageWarning
  } = useMultilingualWarning();
  const shouldShowWelcomeScreenIllustration = isClassicEditorHost(editorHost);
  const contentPadding = isClassicEditorHost(editorHost) ? 'SP2 SP3 SP4 SP3' : 'SP2 SP4 SP4 SP4';
  useOnMount(() => biLogger.panelView({}));
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    boxSizing: "border-box",
    direction: "vertical",
    gap: "SP1",
    height: "100%",
    padding: contentPadding
  }, !hasSavePermission && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(MissingSavePermissionWarning, null)), !isPublishedBranch && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(SecondaryBranchWarning, null)), shouldShowSecondaryLanguageWarning && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(SecondaryLanguageWarning, null)), shouldShowWelcomeScreenIllustration && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    boxSizing: "border-box",
    direction: "vertical",
    paddingBottom: "SP2",
    paddingTop: shouldShowSecondaryLanguageWarning ? '0' : '76px'
  }, /*#__PURE__*/React.createElement(WelcomeScreenClassicEditor, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px",
    paddingTop: shouldShowSecondaryLanguageWarning || shouldShowWelcomeScreenIllustration ? '0' : '64px',
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, isClassicEditorHost(editorHost) ? t('accessibility-wizard.welcome-screen.title.classic-editor') : t('accessibility-wizard.welcome-screen.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, isClassicEditorHost(editorHost) ? t('accessibility-wizard.welcome-screen.description.classic-editor') : t('accessibility-wizard.welcome-screen.description'))));
};
//# sourceMappingURL=wizard-panel-content-welcome.js.map